import React from 'react';
import MarketingLayout from './MarketingLayout';

const CSS = `
  .legal-body { max-width: 780px; margin: 0 auto; padding: 60px 24px 100px; font-family: 'Inter', sans-serif; color: #0f172a; -webkit-font-smoothing: antialiased; }
  .legal-body h1 { font-size: 36px; font-weight: 800; letter-spacing: -1.5px; margin-bottom: 8px; color: #0f172a; }
  .legal-body .legal-date { font-size: 14px; color: #94a3b8; margin-bottom: 40px; }
  .legal-body h2 { font-size: 20px; font-weight: 700; color: #0f172a; margin: 36px 0 12px; }
  .legal-body h3 { font-size: 16px; font-weight: 600; color: #0f172a; margin: 24px 0 8px; }
  .legal-body p  { font-size: 15px; color: #475569; line-height: 1.8; margin-bottom: 14px; }
  .legal-body ul { padding-left: 20px; margin-bottom: 14px; }
  .legal-body ul li { font-size: 15px; color: #475569; line-height: 1.8; margin-bottom: 6px; }
  .legal-body a  { color: #2563eb; text-decoration: none; }
  .legal-body a:hover { text-decoration: underline; }
  .legal-divider { height: 1px; background: #f1f5f9; margin: 32px 0; }
  .legal-toc { background: #f8fafc; border: 1px solid #e2e8f0; border-radius: 14px; padding: 24px 28px; margin-bottom: 40px; }
  .legal-toc ul { padding-left: 20px; }
  .legal-toc li { font-size: 14px; margin-bottom: 6px; }
`;

export default function LegalPage({ title, updated, children }) {
  return (
    <MarketingLayout>
      <style>{CSS}</style>
      <div className="legal-body">
        <h1>{title}</h1>
        {updated && <p className="legal-date">Last updated: {updated}</p>}
        {children}
      </div>
    </MarketingLayout>
  );
}
